import React, { useEffect, useState } from 'react';
import quickReferenceBackground from '../quickreferencebackground.webp'; // Updated background image import
import buttonImage from '../buttonimage.webp';
import { supabase } from '../supabaseClient';

export default function HealingFormulasPage({ goBack, goHome, setPageHistory, currentPage, setCurrentPage }) {
    
    const [showAgreement, setShowAgreement] = useState(false);
    const [pendingNavigation, setPendingNavigation] = useState(false);

    useEffect(() => {
        const savedScrollPosition = sessionStorage.getItem('scrollPosition');
        if (savedScrollPosition) {
            window.scrollTo(0, parseInt(savedScrollPosition, 10));
            sessionStorage.removeItem('scrollPosition');
        }
    }, []);

    

    const handleSaveProgress = async () => {
        try {
            const { data: { user }, error: userError } = await supabase.auth.getUser();
            if (userError || !user) {
                console.error('Error fetching user:', userError);
                alert('User not logged in!');
                return;
            }

            const { error: progressError } = await supabase
                .from('user_progress')
                .upsert({
                    user_id: user.id,
                    current_question_id: null,
                    current_component: 'healingFormulasPage',
                    animated_helper: 'no', // <-- ensure this is always set to 'no'
                    timestamp: new Date().toISOString(),
                });

            if (progressError) {
                console.error('Error saving progress:', progressError.message);
                alert('Failed to save progress: ' + progressError.message);
                return;
            }

            alert('Progress saved successfully!');
        } catch (err) {
            console.error('Unexpected error saving progress:', err);
            alert('An unexpected error occurred while saving progress.');
        }
    };

    // Helper to check user profile before proceeding
    const handleSelfHealingSessionClick = async () => {
        try {
            const { data: { user }, error: userError } = await supabase.auth.getUser();
            if (userError || !user) {
                alert('User not logged in!');
                return;
            }
            // Example profile check (customize as needed)
            const { data: profile, error: profileError } = await supabase
                .from('user_profiles')
                .select('id')
                .eq('id', user.id)
                .single();
            if (profileError || !profile) {
                alert('Profile not found or not permitted.');
                return;
            }
            // Passed check, show agreement modal
            setShowAgreement(true);
            setPendingNavigation(true);
        } catch (err) {
            alert('Unexpected error during profile check.');
        }
    };

    const setCurrentPageWithHistory = (page) => {
        setPageHistory((prev) => [...prev, currentPage]);
        setCurrentPage(page);
    };

    return (
        <div style={{
            backgroundImage: `url(${quickReferenceBackground})`, // Updated background image
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            padding: '16px',
            marginBottom: '80px', // space for sticky footer
            boxSizing: 'border-box',
        }}>
            {/* Agreement Modal */}
            {showAgreement && (
                <div style={{
                    position: 'fixed',
                    top: 0, left: 0, width: '100vw', height: '100vh',
                    background: 'rgba(0,0,0,0.5)',
                    zIndex: 2000,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                    <div style={{
                        background: 'white',
                        borderRadius: '12px',
                        padding: '32px 24px',
                        maxWidth: '400px',
                        boxShadow: '0 4px 16px rgba(0,0,0,0.3)',
                        textAlign: 'center'
                    }}>
                        <div style={{ marginBottom: 24, fontFamily: 'Times New Roman, Times, serif', fontSize: 16, color: '#222' }}>
                            I agree that I am safe to proceed.<br /><br />
                            I agree that it is my responsibility to care for myself through this process.<br /><br />
                            I will stay hydrated through and after this process.<br /><br />
                            I have read the tutorial on the Home page prior to proceeding.
                            <br /><br />
                            <span style={{ color: '#3B839B', fontWeight: 'bold', fontSize: 14 }}>
                                (Your session has started and will expire in 24 hours for free subscriptions)
                            </span>
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0 }}>
                            <button
                                style={{
                                    backgroundImage: `url(${buttonImage})`,
                                    backgroundSize: 'cover',
                                    border: '2px solid #4B5563',
                                    borderRadius: '8px',
                                    padding: '10px 20px',
                                    color: 'white',
                                    fontWeight: 'bold',
                                    fontFamily: 'Times New Roman, Times, serif',
                                    fontSize: '16px',
                                    cursor: 'pointer',
                                    marginBottom: '12px',
                                    width: '180px',
                                }}
                                onClick={() => {
                                    setShowAgreement(false);
                                    if (pendingNavigation) {
                                        setCurrentPageWithHistory('healingFormulas');
                                        setPendingNavigation(false);
                                    }
                                }}
                            >
                                OK
                            </button>
                            <br />
                            <button
                                style={{
                                    background: '#3B839B',
                                    border: '2px solid #3B839B',
                                    borderRadius: '8px',
                                    padding: '10px 20px',
                                    color: 'white',
                                    fontWeight: 'bold',
                                    fontFamily: 'Times New Roman, Times, serif',
                                    fontSize: '16px',
                                    cursor: 'pointer',
                                    width: '180px',
                                    marginBottom: '12px',
                                }}
                                onClick={() => {
                                    setShowAgreement(false);
                                    setPendingNavigation(false);
                                    setCurrentPageWithHistory('rightForYou');
                                }}
                            >
                                Read Tutorial
                            </button>
                            <button
                                style={{
                                    background: 'white',
                                    border: '2px solid black',
                                    borderRadius: '8px',
                                    padding: '10px 20px',
                                    color: 'black',
                                    fontWeight: 'bold',
                                    fontFamily: 'Times New Roman, Times, serif',
                                    fontSize: '16px',
                                    cursor: 'pointer',
                                    width: '180px',
                                    marginTop: '8px'
                                }}
                                onClick={() => {
                                    setShowAgreement(false);
                                    setPendingNavigation(false);
                                    if (typeof goBack === 'function') goBack();
                                }}
                            >
                                Will return later
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Top Card: Healing Formulas */}
            <div style={{
                maxWidth: '600px',
                width: '100%',
                border: '2px solid black',
                borderRadius: '10px',
                padding: '16px',
                marginBottom: '32px',
                textAlign: 'center',
                backgroundColor: '#6AA2BB', // Updated card background color
                boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
            }}>
                <h3 style={{
                    fontFamily: 'Times New Roman, Times, serif',
                    fontSize: '24px',
                    fontWeight: 'bold',
                    marginBottom: '16px',
                    color: 'white',
                }}>
                    Start or Continue your Interactive Session
                </h3>
                <button
                    style={{
                        backgroundImage: `url(${buttonImage})`,
                        backgroundSize: 'cover',
                        border: '2px solid black',
                        borderRadius: '10px',
                        padding: '15px 20px',
                        width: '340px', // Wider than grid buttons for browser
                        minWidth: '220px',
                        maxWidth: '90%',
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '18px',
                        fontWeight: 'bold',
                        boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                        margin: '0 auto',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        textAlign: 'center',
                        whiteSpace: 'nowrap',
                    }}
                    className="self-healing-session-btn"
                    onClick={handleSelfHealingSessionClick}
                >
                    Self Reflection Session
                </button>
                <style>
                    {`
                    @media (max-width: 600px) {
                        .self-healing-session-btn {
                            width: 80vw !important;
                            min-width: 0 !important;
                            max-width: 95vw !important;
                            font-size: 17px !important;
                            padding: 15px 0 !important;
                            margin: 0 auto !important;
                            display: flex !important;
                            justify-content: center !important;
                        }
                        /* Make grid two columns on mobile */
                        div[style*="display: grid"] {
                            grid-template-columns: repeat(2, 1fr) !important;
                            max-width: 100vw !important;
                        }
                        /* Make cards fit mobile width */
                        div[style*="max-width: '256px'"], div[style*='max-width: 256px'] {
                            max-width: 95vw !important;
                            min-width: 0 !important;
                        }
                    }
                    `}
                </style>
                <p style={{
                    marginTop: '16px',
                    fontFamily: 'Times New Roman, Times, serif',
                    fontSize: '14px',
                    color: 'black',
                    fontWeight: 'bold',
                }}>
                    Step by step guidance tool for reflecting on an energy or energy loop that may be limiting or bothersome.
                </p>
            </div>

            {/* Title for Grid of Cards */}
            <h3 style={{
                fontFamily: 'Times New Roman, Times, serif',
                fontSize: '24px', // Reduced font size by 3 times
                fontWeight: 'bold',
                marginBottom: '16px',
                color: 'white', // Changed color to white
                textAlign: 'center',
            }}>
                Access Specific Concepts Below
            </h3>

            {/* Grid of Remaining Cards */}
            <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(256px, 1fr))',
                gap: '16px',
                width: '100%',
                maxWidth: '1088px',
            }}>
                {/* Abundance */}
                <div style={{
                    maxWidth: '256px',
                    border: '2px solid black',
                    borderRadius: '10px',
                    padding: '16px',
                    backgroundColor: '#3B839B',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}>
                    <button
                        style={{
                            backgroundImage: `url(${buttonImage})`,
                            backgroundSize: 'cover',
                            border: '2px solid black',
                            borderRadius: '10px',
                            padding: '15px 20px',
                            width: '100%',
                            maxWidth: '200px',
                            fontFamily: 'Times New Roman, Times, serif',
                            fontSize: '16px',
                            fontWeight: 'bold',
                            boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                            textAlign: 'center',
                        }}
                        onClick={() => {
                            setCurrentPageWithHistory('healingFormulasPage/abundance');
                        }}
                    >
                        Abundance
                    </button>
                    <p style={{
                        marginTop: '16px',
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '14px',
                        color: 'white',
                        fontWeight: 'bold',
                        textAlign: 'center',
                        wordWrap: 'break-word',
                    }}>
                        Reflect on Cultivating an abundant mindset to line up with prosperity.
                    </p>
                </div>
                {/* Acceptance */}
                <div style={{
                    maxWidth: '256px',
                    border: '2px solid black',
                    borderRadius: '10px',
                    padding: '16px',
                    backgroundColor: '#3B839B',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}>
                    <button
                        style={{
                            backgroundImage: `url(${buttonImage})`,
                            backgroundSize: 'cover',
                            border: '2px solid black',
                            borderRadius: '10px',
                            padding: '15px 20px',
                            width: '100%',
                            maxWidth: '200px',
                            fontFamily: 'Times New Roman, Times, serif',
                            fontSize: '16px',
                            fontWeight: 'bold',
                            boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                            textAlign: 'center',
                        }}
                        onClick={() => {
                            console.log('Debug: Acceptance button clicked'); // Debug log
                            setCurrentPageWithHistory('healingFormulasPage/acceptance'); // Ensure this function is correctly passed as a prop
                        }}
                    >
                        Acceptance
                    </button>
                    <p style={{
                        marginTop: '16px',
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '14px',
                        color: 'white',
                        fontWeight: 'bold',
                        textAlign: 'center',
                        wordWrap: 'break-word',
                    }}>
                        Reflect on acceptance for peace and clarity.
                    </p>
                </div>
                {/* Action */}
                <div style={{
                    maxWidth: '256px',
                    border: '2px solid black',
                    borderRadius: '10px',
                    padding: '16px',
                    backgroundColor: '#3B839B',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}>
                    <button
                        style={{
                            backgroundImage: `url(${buttonImage})`,
                            backgroundSize: 'cover',
                            border: '2px solid black',
                            borderRadius: '10px',
                            padding: '15px 20px',
                            width: '100%',
                            maxWidth: '200px',
                            fontFamily: 'Times New Roman, Times, serif',
                            fontSize: '16px',
                            fontWeight: 'bold',
                            boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                            textAlign: 'center',
                        }}
                        onClick={() => {
                            setCurrentPageWithHistory('healingFormulasPage/action');
                        }}
                    >
                        Action
                    </button>
                    <p style={{
                        marginTop: '16px',
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '14px',
                        color: 'white',
                        fontWeight: 'bold',
                        textAlign: 'center',
                        wordWrap: 'break-word',
                    }}>
                        Reflect on the importance of taking Action.
                    </p>
                </div>
                {/* Acknowledge */}
                <div style={{
                    maxWidth: '256px',
                    border: '2px solid black',
                    borderRadius: '10px',
                    padding: '16px',
                    backgroundColor: '#3B839B',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}>
                    <button
                        className="center-mobile-btn"
                        style={{
                            backgroundImage: `url(${buttonImage})`,
                            backgroundSize: 'cover',
                            border: '2px solid black',
                            borderRadius: '10px',
                            padding: '10px 10px',
                            width: '100%',
                            maxWidth: '200px',
                            fontFamily: 'Times New Roman, Times, serif',
                            fontSize: '16px',
                            fontWeight: 'bold',
                            boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                            textAlign: 'center',
                        }}
                        onClick={() => {
                            setCurrentPageWithHistory('healingFormulasPage/acknowledge');
                        }}
                    >
                        Acknowledge
                    </button>
                    <p style={{
                        marginTop: '16px',
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '14px',
                        color: 'white',
                        fontWeight: 'bold',
                        textAlign: 'center',
                        wordWrap: 'break-word',
                    }}>
                        Reflect on Acknowledging what is in front of you.
                    </p>
                </div>
                {/* Accomplishments */}
                <div style={{
                    maxWidth: '256px',
                    border: '2px solid black',
                    borderRadius: '10px',
                    padding: '16px',
                    backgroundColor: '#3B839B',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}>
                    <button
                        style={{
                            backgroundImage: `url(${buttonImage})`,
                            backgroundSize: 'cover',
                            border: '2px solid black',
                            borderRadius: '10px',
                            padding: '2px 2px',
                            width: '100%',
                            maxWidth: '200px',
                            fontFamily: 'Times New Roman, Times, serif',
                            fontSize: '14px',
                            fontWeight: 'bold',
                            boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                            textAlign: 'center',
                        }}
                        onClick={() => {
                            setCurrentPageWithHistory('healingFormulasPage/accomplishments');
                        }}
                    >
                        Accomplishments
                    </button>
                    <p style={{
                        marginTop: '16px',
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '14px',
                        color: 'white',
                        fontWeight: 'bold',
                        textAlign: 'center',
                        wordWrap: 'break-word',
                    }}>
                        Reflect on your accomplishments.
                    </p>
                </div>
                {/* Affirmations */}
                <div style={{
                    maxWidth: '256px',
                    border: '2px solid black',
                    borderRadius: '10px',
                    padding: '16px',
                    backgroundColor: '#3B839B',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}>
                    <button
                        className="center-mobile-btn"
                        style={{
                            backgroundImage: `url(${buttonImage})`,
                            backgroundSize: 'cover',
                            border: '2px solid black',
                            borderRadius: '10px',
                            padding: '15px 10px',
                            width: '100%',
                            maxWidth: '200px',
                            fontFamily: 'Times New Roman, Times, serif',
                            fontSize: '16px',
                            fontWeight: 'bold',
                            boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                            textAlign: 'center',
                        }}
                        onClick={() => {
                            setCurrentPageWithHistory('healingFormulasPage/affirmations');
                        }}
                    >
                        Affirmations
                    </button>
                    <p style={{
                        marginTop: '16px',
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '14px',
                        color: 'white',
                        fontWeight: 'bold',
                        textAlign: 'center',
                        wordWrap: 'break-word',
                    }}>
                        Reflect on what is important to you in your day to day life.
                    </p>
                </div>
                {/* Celebrate */}
                <div style={{
                    maxWidth: '256px',
                    border: '2px solid black',
                    borderRadius: '10px',
                    padding: '16px',
                    backgroundColor: '#3B839B',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}>
                    <button
                        style={{
                            backgroundImage: `url(${buttonImage})`,
                            backgroundSize: 'cover',
                            border: '2px solid black',
                            borderRadius: '10px',
                            padding: '15px 20px',
                            width: '100%',
                            maxWidth: '200px',
                            fontFamily: 'Times New Roman, Times, serif',
                            fontSize: '16px',
                            fontWeight: 'bold',
                            boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                            textAlign: 'center',
                        }}
                        onClick={() => setCurrentPageWithHistory('healingFormulasPage/celebrate')}
                    >
                        Celebrate
                    </button>
                    <p style={{
                        marginTop: '16px',
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '16px',
                        color: 'white',
                        fontWeight: 'bold',
                        textAlign: 'center',
                        wordWrap: 'break-word',
                    }}>
                        Reflect on Celebrating any progress, no matter how small.
                    </p>
                </div>
                {/* Change a Belief */}
                <div style={{
                    maxWidth: '256px',
                    border: '2px solid black',
                    borderRadius: '10px',
                    padding: '16px',
                    backgroundColor: '#3B839B',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}>
                    <button
                        style={{
                            backgroundImage: `url(${buttonImage})`,
                            backgroundSize: 'cover',
                            border: '2px solid black',
                            borderRadius: '10px',
                            padding: '5px 10px',
                            width: '100%',
                            maxWidth: '200px',
                            fontFamily: 'Times New Roman, Times, serif',
                            fontSize: '16px',
                            fontWeight: 'bold',
                            boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                            textAlign: 'center',
                        }}
                        onClick={() => {
                            setCurrentPageWithHistory('healingFormulasPage/changeABelief');
                        }}
                    >
                        Change a Belief
                    </button>
                    <p style={{
                        marginTop: '16px',
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '14px',
                        color: 'white',
                        fontWeight: 'bold',
                        textAlign: 'center',
                        wordWrap: 'break-word',
                    }}>
                        Reflect on identify limiting beliefs and creating change.
                    </p>
                </div>
                {/* Communication - appear before Comfort Zone */}
                <div style={{
                    maxWidth: '256px',
                    border: '2px solid black',
                    borderRadius: '10px',
                    padding: '16px',
                    backgroundColor: '#3B839B',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}>
                    <button
                        style={{
                            backgroundImage: `url(${buttonImage})`,
                            backgroundSize: 'cover',
                            border: '2px solid black',
                            borderRadius: '10px',
                            padding: '15px 10px',
                            width: '100%',
                            maxWidth: '200px',
                            fontFamily: 'Times New Roman, Times, serif',
                            fontSize: '14px',
                            fontWeight: 'bold',
                            boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                            textAlign: 'center',
                        }}
                        onClick={() => setCurrentPageWithHistory('healingFormulasPage/communication')}
                    >
                        Communication
                    </button>
                    <p style={{
                        marginTop: '16px',
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '14px',
                        color: 'white',
                        fontWeight: 'bold',
                        textAlign: 'center',
                        wordWrap: 'break-word',
                    }}>
                        Reflect on the Communication that happens on many levels.
                    </p>
                </div>
                {/* Coping */}
                <div style={{
                    maxWidth: '256px',
                    border: '2px solid black',
                    borderRadius: '10px',
                    padding: '16px',
                    backgroundColor: '#3B839B',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}>
                    <button
                        style={{
                            backgroundImage: `url(${buttonImage})`,
                            backgroundSize: 'cover',
                            border: '2px solid black',
                            borderRadius: '10px',
                            padding: '15px 20px',
                            width: '100%',
                            maxWidth: '200px',
                            fontFamily: 'Times New Roman, Times, serif',
                            fontSize: '16px',
                            fontWeight: 'bold',
                            boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                            textAlign: 'center',
                        }}
                        onClick={() => {
                            setCurrentPageWithHistory('healingFormulasPage/coping');
                        }}
                    >
                        Coping
                    </button>
                    <p style={{
                        marginTop: '16px',
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '14px',
                        color: 'white',
                        fontWeight: 'bold',
                        textAlign: 'center',
                        wordWrap: 'break-word',
                    }}>
                        Reflect on Coping and how it is used.
                    </p>
                </div>
                {/* Dream */}
                <div style={{
                    maxWidth: '256px',
                    border: '2px solid black',
                    borderRadius: '10px',
                    padding: '16px',
                    backgroundColor: '#3B839B',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}>
                    <button
                        style={{
                            backgroundImage: `url(${buttonImage})`,
                            backgroundSize: 'cover',
                            border: '2px solid black',
                            borderRadius: '10px',
                            padding: '15px 20px',
                            width: '100%',
                            maxWidth: '200px',
                            fontFamily: 'Times New Roman, Times, serif',
                            fontSize: '16px',
                            fontWeight: 'bold',
                            boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                            textAlign: 'center',
                        }}
                        onClick={() => {
                            setCurrentPageWithHistory('healingFormulasPage/dream');
                        }}
                    >
                        Dream
                    </button>
                    <p style={{
                        marginTop: '16px',
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '14px',
                        color: 'white',
                        fontWeight: 'bold',
                        textAlign: 'center',
                        wordWrap: 'break-word',
                    }}>
                        Reflect on the concept of dreaming.
                    </p>
                </div>
                {/* Energy Movement */}
                <div style={{
                    maxWidth: '256px',
                    border: '2px solid black',
                    borderRadius: '10px',
                    padding: '16px',
                    backgroundColor: '#3B839B',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}>
                    <button
                        style={{
                            backgroundImage: `url(${buttonImage})`,
                            backgroundSize: 'cover',
                            border: '2px solid black',
                            borderRadius: '10px',
                            padding: '4px 20px',
                            width: '100%',
                            maxWidth: '200px',
                            fontFamily: 'Times New Roman, Times, serif',
                            fontSize: '16px',
                            fontWeight: 'bold',
                            boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                            textAlign: 'center',
                        }}
                        onClick={() => {
                            setCurrentPageWithHistory('healingFormulasPage/energyHealing');
                        }}
                    >
                        Energy
                    </button>
                    <p style={{
                        marginTop: '16px',
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '14px',
                        color: 'white',
                        fontWeight: 'bold',
                        textAlign: 'center',
                        wordWrap: 'break-word',
                    }}>
                        Reflect on energy, and how to work with energy.
                    </p>
                </div>
                {/* Faith */}
                <div style={{
                    maxWidth: '256px',
                    border: '2px solid black',
                    borderRadius: '10px',
                    padding: '16px',
                    backgroundColor: '#3B839B',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}>
                    <button
                        style={{
                            backgroundImage: `url(${buttonImage})`,
                            backgroundSize: 'cover',
                            border: '2px solid black',
                            borderRadius: '10px',
                            padding: '15px 20px',
                            width: '100%',
                            maxWidth: '200px',
                            fontFamily: 'Times New Roman, Times, serif',
                            fontSize: '16px',
                            fontWeight: 'bold',
                            boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                            textAlign: 'center',
                        }}
                        onClick={() => {
                            setCurrentPageWithHistory('healingFormulasPage/faith');
                        }}
                    >
                        Faith
                    </button>
                    <p style={{
                        marginTop: '16px',
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '14px',
                        color: 'white',
                        fontWeight: 'bold',
                        textAlign: 'center',
                        wordWrap: 'break-word',
                    }}>
                        Reflect on trust in life and self.
                    </p>
                </div>
                {/* Gratitude */}
                <div style={{
                    maxWidth: '256px',
                    border: '2px solid black',
                    borderRadius: '10px',
                    padding: '16px',
                    backgroundColor: '#3B839B',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}>
                    <button
                        style={{
                            backgroundImage: `url(${buttonImage})`,
                            backgroundSize: 'cover',
                            border: '2px solid black',
                            borderRadius: '10px',
                            padding: '15px 20px',
                            width: '100%',
                            maxWidth: '200px',
                            fontFamily: 'Times New Roman, Times, serif',
                            fontSize: '16px',
                            fontWeight: 'bold',
                            boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                            textAlign: 'center',
                        }}
                        onClick={() => {
                            setCurrentPageWithHistory('healingFormulasPage/gratitude');
                        }}
                    >
                        Gratitude
                    </button>
                    <p style={{
                        marginTop: '16px',
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '14px',
                        color: 'white',
                        fontWeight: 'bold',
                        textAlign: 'center',
                        wordWrap: 'break-word',
                    }}>
                        Reflect on what is said to be one of the highest vibrational states.
                    </p>
                </div>
                {/* Hidden Benefits */}
                <div style={{
                    maxWidth: '256px',
                    border: '2px solid black',
                    borderRadius: '10px',
                    padding: '16px',
                    backgroundColor: '#3B839B',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}>
                    <button
                        style={{
                            backgroundImage: `url(${buttonImage})`,
                            backgroundSize: 'cover',
                            border: '2px solid black',
                            borderRadius: '10px',
                            padding: '5px 10px',
                            width: '100%',
                            maxWidth: '200px',
                            fontFamily: 'Times New Roman, Times, serif',
                            fontSize: '16px',
                            fontWeight: 'bold',
                            boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                            textAlign: 'center',
                        }}
                        onClick={() => {
                            setCurrentPageWithHistory('healingFormulasPage/hiddenBenefits');
                        }}
                    >
                        Hidden Benefits
                    </button>
                    <p style={{
                        marginTop: '16px',
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '14px',
                        color: 'white',
                        fontWeight: 'bold',
                        textAlign: 'center',
                        wordWrap: 'break-word',
                    }}>
                        Reflect on the hidden benefits holding you back.
                    </p>
                </div>
                {/* Honor */}
                <div style={{
                    maxWidth: '256px',
                    border: '2px solid black',
                    borderRadius: '10px',
                    padding: '16px',
                    backgroundColor: '#3B839B',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}>
                    <button
                        style={{
                            backgroundImage: `url(${buttonImage})`,
                            backgroundSize: 'cover',
                            border: '2px solid black',
                            borderRadius: '10px',
                            padding: '15px 20px',
                            width: '100%',
                            maxWidth: '200px',
                            fontFamily: 'Times New Roman, Times, serif',
                            fontSize: '16px',
                            fontWeight: 'bold',
                            boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                            textAlign: 'center',
                        }}
                        onClick={() => {
                            setCurrentPageWithHistory('healingFormulasPage/honor');
                        }}
                    >
                        Honor
                    </button>
                    <p style={{
                        marginTop: '16px',
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '14px',
                        color: 'white',
                        fontWeight: 'bold',
                        textAlign: 'center',
                        wordWrap: 'break-word',
                    }}>
                        Reflect on Honoring your journey, experiences, yourself and others.
                    </p>
                </div>
                {/* Identify The Feeling */}
                                {/* Reflection */}
                                <div style={{
                                    maxWidth: '256px',
                                    border: '2px solid black',
                                    borderRadius: '10px',
                                    padding: '16px',
                                    backgroundColor: '#3B839B',
                                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                }}>
                                    <button
                                        style={{
                                            backgroundImage: `url(${buttonImage})`,
                                            backgroundSize: 'cover',
                                            border: '2px solid black',
                                            borderRadius: '10px',
                                            padding: '15px 20px',
                                            width: '100%',
                                            maxWidth: '200px',
                                            fontFamily: 'Times New Roman, Times, serif',
                                            fontSize: '16px',
                                            fontWeight: 'bold',
                                            boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                                            textAlign: 'center',
                                        }}
                                        onClick={() => setCurrentPageWithHistory('healingFormulasPage/reflection')}
                                    >
                                        Reflection
                                    </button>
                                    <p style={{
                                        marginTop: '16px',
                                        fontFamily: 'Times New Roman, Times, serif',
                                        fontSize: '14px',
                                        color: 'white',
                                        fontWeight: 'bold',
                                        textAlign: 'center',
                                        wordWrap: 'break-word',
                                    }}>
                                        Learn how reflection can help you gain clarity and insight.
                                    </p>
                                </div>
                <div style={{
                    maxWidth: '256px',
                    border: '2px solid black',
                    borderRadius: '10px',
                    padding: '16px',
                    backgroundColor: '#3B839B',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}>
                    <button
                        style={{
                            backgroundImage: `url(${buttonImage})`,
                            backgroundSize: 'cover',
                            border: '2px solid black',
                            borderRadius: '10px',
                            padding: '5px 10px',
                            width: '100%',
                            maxWidth: '200px',
                            fontFamily: 'Times New Roman, Times, serif',
                            fontSize: '16px',
                            fontWeight: 'bold',
                            boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                            textAlign: 'center',
                        }}
                        onClick={() => setCurrentPageWithHistory('healingFormulasPage/identifyTheFeeling')}
                    >
                        Identify The Feeling
                    </button>
                    <p style={{
                        marginTop: '16px',
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '14px',
                        color: 'white',
                        fontWeight: 'bold',
                        textAlign: 'center',
                        wordWrap: 'break-word',
                    }}>
                        Reflect on identify and naming your feelings for clarity.
                    </p>
                </div>

                {/* Mirror Card - now styled like the others */}
                <div style={{
                    maxWidth: '256px',
                    border: '2px solid black',
                    borderRadius: '10px',
                    padding: '10px',
                    backgroundColor: '#3B839B',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}>
                    <button
                        style={{
                            backgroundImage: `url(${buttonImage})`,
                            backgroundSize: 'cover',
                            border: '2px solid black',
                            borderRadius: '10px',
                            padding: '5px 5px',
                            width: '100%',
                            maxWidth: '200px',
                            fontFamily: 'Times New Roman, Times, serif',
                            fontSize: '16px',
                            fontWeight: 'bold',
                            boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                            textAlign: 'center',
                        }}
                        onClick={() => setCurrentPageWithHistory('mirror')}
                    >
                        Mirror
                    </button>
                    <p
                        style={{
                            marginTop: '10px',
                            fontFamily: 'Times New Roman, Times, serif',
                            fontSize: '14px',
                            color: 'white',
                            fontWeight: 'bold',
                            textAlign: 'center',
                            wordWrap: 'break-word',
                        }}
                    >
                        What is being reflected back to you is important to take note of.
                    </p>
                </div>
                {/* One Time Issue */}
                <div style={{
                    maxWidth: '256px',
                    border: '2px solid black',
                    borderRadius: '10px',
                    padding: '16px',
                    backgroundColor: '#3B839B',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}>
                    <button
                        style={{
                            backgroundImage: `url(${buttonImage})`,
                            backgroundSize: 'cover',
                            border: '2px solid black',
                            borderRadius: '10px',
                            padding: '5px 10px',
                            width: '100%',
                            maxWidth: '200px',
                            fontFamily: 'Times New Roman, Times, serif',
                            fontSize: '16px',
                            fontWeight: 'bold',
                            boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                            textAlign: 'center',
                        }}
                        onClick={() => {
                            setCurrentPageWithHistory('healingFormulasPage/oneTimeIssue');
                        }}
                    >
                        One Time Issue
                    </button>
                    <p style={{
                        marginTop: '16px',
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '14px',
                        color: 'white',
                        fontWeight: 'bold',
                        textAlign: 'center',
                        wordWrap: 'break-word',
                    }}>
                        Reflect on being present with and processing a challenging experience.
                    </p>
                </div>
                {/* Presence */}
                <div style={{
                    maxWidth: '256px',
                    border: '2px solid black',
                    borderRadius: '10px',
                    padding: '16px',
                    backgroundColor: '#3B839B',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}>
                    <button
                        style={{
                            backgroundImage: `url(${buttonImage})`,
                            backgroundSize: 'cover',
                            border: '2px solid black',
                            borderRadius: '10px',
                            padding: '15px 20px',
                            width: '100%',
                            maxWidth: '200px',
                            fontFamily: 'Times New Roman, Times, serif',
                            fontSize: '16px',
                            fontWeight: 'bold',
                            boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                            textAlign: 'center',
                        }}
                        onClick={() => {
                            setCurrentPageWithHistory('healingFormulasPage/presence');
                        }}
                    >
                        Presence
                    </button>
                    <p style={{
                        marginTop: '16px',
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '14px',
                        color: 'white', // Updated text color for better contrast
                        fontWeight: 'bold', // Bolded description text
                        textAlign: 'center',
                        wordWrap: 'break-word',
                    }}>
                        Reflect on Presence as a tool for moving through unprocessed past.
                    </p>
                </div>
                {/* Resistance */}
                <div style={{
                    maxWidth: '256px',
                    border: '2px solid black',
                    borderRadius: '10px',
                    padding: '16px',
                    backgroundColor: '#3B839B',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}>
                    <button
                        style={{
                            backgroundImage: `url(${buttonImage})`,
                            backgroundSize: 'cover',
                            border: '2px solid black',
                            borderRadius: '10px',
                            padding: '15px 20px',
                            width: '100%',
                            maxWidth: '200px',
                            fontFamily: 'Times New Roman, Times, serif',
                            fontSize: '16px',
                            fontWeight: 'bold',
                            boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                            textAlign: 'center',
                        }}
                        onClick={() => {
                            setCurrentPageWithHistory('healingFormulasPage/resistance');
                        }}
                    >
                        Resistance
                    </button>
                    <p style={{
                        marginTop: '16px',
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '14px',
                        color: 'white',
                        fontWeight: 'bold',
                        textAlign: 'center',
                        wordWrap: 'break-word',
                    }}>
                        Reflect on the role resistance has in your life.
                    </p>
                </div>
                {/* Self Care */}
                <div style={{
                    maxWidth: '256px',
                    border: '2px solid black',
                    borderRadius: '10px',
                    padding: '16px',
                    backgroundColor: '#3B839B',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}>
                    <button
                        style={{
                            backgroundImage: `url(${buttonImage})`,
                            backgroundSize: 'cover',
                            border: '2px solid black',
                            borderRadius: '10px',
                            padding: '15px 20px',
                            width: '100%',
                            maxWidth: '200px',
                            fontFamily: 'Times New Roman, Times, serif',
                            fontSize: '16px',
                            fontWeight: 'bold',
                            boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                            textAlign: 'center',
                        }}
                        onClick={() => {

                            setCurrentPageWithHistory('healingFormulasPage/selfCare');
                        }}
                    >
                        Self Care
                   
                    </button>
                    <p style={{
                        marginTop: '16px',
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '14px',
                        color: 'white', // Updated text color for better contrast
                        fontWeight: 'bold', // Bolded description text
                        textAlign: 'center',
                        wordWrap: 'break-word',
                    }}>
                        Reflect on what is the best thing for you to do for yourself now
                    </p>
                </div>
                {/* Strengths */}
                <div style={{
                    maxWidth: '256px',
                    border: '2px solid black',
                    borderRadius: '10px',
                    padding: '16px',
                    backgroundColor: '#3B839B',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}>
                    <button
                        style={{
                            backgroundImage: `url(${buttonImage})`,
                            backgroundSize: 'cover',
                            border: '2px solid black',
                            borderRadius: '10px',
                            padding: '15px 20px',
                            width: '100%',
                            maxWidth: '200px',
                            fontFamily: 'Times New Roman, Times, serif',
                            fontSize: '16px',
                            fontWeight: 'bold',
                            boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                            textAlign: 'center',
                        }}
                        onClick={() => {
                            setCurrentPageWithHistory('healingFormulasPage/strengths');
                        }}
                    >
                        Strengths
                    </button>
                    <p style={{
                        marginTop: '16px',
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '14px',
                        color: 'white',
                        fontWeight: 'bold',
                        textAlign: 'center',
                        wordWrap: 'break-word',
                    }}>
                        Reflect on recognizing and building upon your strengths.
                    </p>
                </div>
                {/* Subconscious */}
                <div style={{
                    maxWidth: '256px',
                    border: '2px solid black',
                    borderRadius: '10px',
                    padding: '16px',
                    backgroundColor: '#3B839B',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}>
                    <button
                        className="center-mobile-btn"
                        style={{
                            backgroundImage: `url(${buttonImage})`,
                            backgroundSize: 'cover',
                            border: '2px solid black',
                            borderRadius: '10px',
                            padding: '5px 10px',
                            width: '100%',
                            maxWidth: '200px',
                            fontFamily: 'Times New Roman, Times, serif',
                            fontSize: '16px',
                            fontWeight: 'bold',
                            boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                            textAlign: 'center',
                        }}
                        onClick={() => {
                            setCurrentPageWithHistory('healingFormulasPage/subconscious');
                        }}
                    >
                        Subconscious
                    </button>
                    <p style={{
                        marginTop: '16px',
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '14px',
                        color: 'white',
                        fontWeight: 'bold',
                        textAlign: 'center',
                        wordWrap: 'break-word',
                    }}>
                        Reflect on the subconscious mind to uncover hidden patterns.
                    </p>
                </div>
                {/* Trauma */}
                <div style={{
                    maxWidth: '256px',
                    border: '2px solid black',
                    borderRadius: '10px',
                    padding: '16px',
                    backgroundColor: '#3B839B',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}>
                    <button
                        style={{
                            backgroundImage: `url(${buttonImage})`,
                            backgroundSize: 'cover',
                            border: '2px solid black',
                            borderRadius: '10px',
                            padding: '15px 20px',
                            width: '100%',
                            maxWidth: '200px',
                            fontFamily: 'Times New Roman, Times, serif',
                            fontSize: '16px',
                            fontWeight: 'bold',
                            boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                            textAlign: 'center',
                        }}
                        onClick={() => {
                            setCurrentPageWithHistory('healingFormulasPage/trauma');
                        }}
                    >
                        Trauma
                    </button>
                    <p style={{
                        marginTop: '16px',
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '14px',
                        color: 'white',
                        fontWeight: 'bold',
                        textAlign: 'center',
                        wordWrap: 'break-word',
                    }}>
                        A reflection on unresolved trauma in life.
                    </p>
                </div>
                {/* Values */}
                <div style={{
                    maxWidth: '256px',
                    border: '2px solid black',
                    borderRadius: '10px',
                    padding: '16px',
                    backgroundColor: '#3B839B',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}>
                    <button
                        style={{
                            backgroundImage: `url(${buttonImage})`,
                            backgroundSize: 'cover',
                            border: '2px solid black',
                            borderRadius: '10px',
                            padding: '15px 20px',
                            width: '100%',
                            maxWidth: '200px',
                            fontFamily: 'Times New Roman, Times, serif',
                            fontSize: '16px',
                            fontWeight: 'bold',
                            boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                            textAlign: 'center',
                        }}
                        onClick={() => {
                            setCurrentPageWithHistory('healingFormulasPage/values');
                        }}
                    >
                        Values
                    </button>
                    <p style={{
                        marginTop: '16px',
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '14px',
                        color: 'white',
                        fontWeight: 'bold',
                        textAlign: 'center',
                        wordWrap: 'break-word',
                    }}>
                        Explore and reflect on what is important to you and why.
                    </p>
                </div>
                {/* Weaknesses */}
                <div
                    style={{
                        maxWidth: '256px',
                        border: '2px solid black',
                        borderRadius: '10px',
                        padding: '16px',
                        backgroundColor: '#3B839B',
                        boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                    className="weaknesses-card"
                >
                    <button
                        style={{
                            backgroundImage: `url(${buttonImage})`,
                            backgroundSize: 'cover',
                            border: '2px solid black',
                            borderRadius: '10px',
                            padding: '15px 20px',
                            width: '100%',
                            maxWidth: '200px',
                            fontFamily: 'Times New Roman, Times, serif',
                            fontSize: '16px',
                            fontWeight: 'bold',
                            boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                            textAlign: 'center',
                        }}
                        onClick={() => {
                            setCurrentPageWithHistory('healingFormulasPage/weaknesses');
                        }}
                    >
                        Weaknesses
                    </button>
                    <style>
                        {`
                        @media (max-width: 600px) {
                            .weaknesses-card {
                                padding-top: 6px !important;
                            }
                        }
                        `}
                    </style>
                    <p style={{
                        marginTop: '16px',
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '14px',
                        color: 'white',
                        fontWeight: 'bold',
                        textAlign: 'center',
                        wordWrap: 'break-word',
                    }}>
                        Explore and reflect on areas of weakness in your life.
                    </p>
                </div>
                {/* Witness */}
                <div style={{
                    maxWidth: '256px',
                    border: '2px solid black',
                    borderRadius: '10px',
                    padding: '16px',
                    backgroundColor: '#3B839B',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}>
                    <button
                        style={{
                            backgroundImage: `url(${buttonImage})`,
                            backgroundSize: 'cover',
                            border: '2px solid black',
                            borderRadius: '10px',
                            padding: '15px 20px',
                            width: '100%',
                            maxWidth: '200px',
                            fontFamily: 'Times New Roman, Times, serif',
                            fontSize: '16px',
                            fontWeight: 'bold',
                            boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                            textAlign: 'center',
                        }}
                        onClick={() => {
                            setCurrentPageWithHistory('healingFormulasPage/witness');
                        }}
                    >
                        Witness
                    </button>
                    <p style={{
                        marginTop: '16px',
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '14px',
                        color: 'white',
                        fontWeight: 'bold',
                        textAlign: 'center',
                        wordWrap: 'break-word',
                    }}>
                        Reflect on the power of being witnessed. Explore this concept.
                    </p>
                </div>
                {/* Rest */}
                <div style={{
                    maxWidth: '256px',
                    border: '2px solid black',
                    borderRadius: '10px',
                    padding: '16px',
                    backgroundColor: '#3B839B',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}>
                    <button
                        style={{
                            backgroundImage: `url(${buttonImage})`,
                            backgroundSize: 'cover',
                            border: '2px solid black',
                            borderRadius: '10px',
                            padding: '15px 20px',
                            width: '100%',
                            maxWidth: '200px',
                            fontFamily: 'Times New Roman, Times, serif',
                            fontSize: '16px',
                            fontWeight: 'bold',
                            boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                            textAlign: 'center',
                        }}
                        onClick={() => setCurrentPageWithHistory('healingFormulasPage/rest')}
                    >
                        Rest
                    </button>
                    <p style={{
                        marginTop: '16px',
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '14px',
                        color: 'white',
                        fontWeight: 'bold',
                        textAlign: 'center',
                        wordWrap: 'break-word',
                    }}>
                        Reflect on the importance of Rest.
                    </p>
                </div>
             {/* Unknown */}
                <div style={{
                    maxWidth: '256px',
                    border: '2px solid black',
                    borderRadius: '10px',
                    padding: '16px',
                    backgroundColor: '#3B839B',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}>
                    <button
                        style={{
                            backgroundImage: `url(${buttonImage})`,
                            backgroundSize: 'cover',
                            border: '2px solid black',
                            borderRadius: '10px',
                            padding: '15px 20px',
                            width: '100%',
                            maxWidth: '200px',
                            fontFamily: 'Times New Roman, Times, serif',
                            fontSize: '16px',
                            fontWeight: 'bold',
                            boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                            textAlign: 'center',
                        }}
                        onClick={() => setCurrentPageWithHistory('healingFormulasPage/unknown')}
                    >
                        Unknown
                    </button>
                    <p style={{
                        marginTop: '16px',
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '14px',
                        color: 'white',
                        fontWeight: 'bold',
                        textAlign: 'center',
                        wordWrap: 'break-word',
                    }}>
                        Reflect on how comfortable you are with the unknown.
                    </p>
                </div>
                {/* Validation */}
                <div style={{
                    maxWidth: '256px',
                    border: '2px solid black',
                    borderRadius: '10px',
                    padding: '16px',
                    backgroundColor: '#3B839B',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}>
                    <button
                        style={{
                            backgroundImage: `url(${buttonImage})`,
                            backgroundSize: 'cover',
                            border: '2px solid black',
                            borderRadius: '10px',
                            padding: '15px 20px',
                            width: '100%',
                            maxWidth: '200px',
                            fontFamily: 'Times New Roman, Times, serif',
                            fontSize: '16px',
                            fontWeight: 'bold',
                            boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                            textAlign: 'center',
                        }}
                        onClick={() => setCurrentPageWithHistory('healingFormulasPage/validation')}
                    >
                        Validation
                    </button>
                    <p style={{
                        marginTop: '16px',
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '14px',
                        color: 'white',
                        fontWeight: 'bold',
                        textAlign: 'center',
                        wordWrap: 'break-word',
                    }}>
                        Reflect on the importance of Self Validation.
                    </p>
                </div>

                {/* Relationships */}
                <div style={{
                    maxWidth: '256px',
                    border: '2px solid black',
                    borderRadius: '10px',
                    padding: '16px',
                    backgroundColor: '#3B839B',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}>
                    <button
                        style={{
                            backgroundImage: `url(${buttonImage})`,
                            backgroundSize: 'cover',
                            border: '2px solid black',
                            borderRadius: '10px',
                            padding: '15px 10px',
                            width: '100%',
                            maxWidth: '200px',
                            fontFamily: 'Times New Roman, Times, serif',
                            fontSize: '16px',
                            fontWeight: 'bold',
                            boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                            textAlign: 'center',
                        }}
                        onClick={() => setCurrentPageWithHistory('healingFormulasPage/relationships')}
                    >
                        Relationships
                    </button>
                    <p style={{
                        marginTop: '16px',
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '14px',
                        color: 'white',
                        fontWeight: 'bold',
                        textAlign: 'center',
                        wordWrap: 'break-word',
                    }}>
                        Reflect on potential to improve relationships for deeper connection and understanding.
                    </p>
                </div>
            </div>

            {/* Navigation Buttons */}
            <div
                className="healing-formulas-nav-btn-row"
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    gap: '16px',
                    marginTop: '32px',
                    width: '100%',
                    maxWidth: '100vw', // Prevent overflow
                    flexWrap: 'wrap',
                    boxSizing: 'border-box',
                }}
            >
                <button style={{
                    backgroundImage: `url(${buttonImage})`,

                    backgroundSize: 'cover',
                    border: '2px solid black',
                    borderRadius: '10px',
                    padding: '10px 20px',
                    width: '120px',
                    fontFamily: 'Times New Roman, Times, serif',
                    fontSize: '16px',
                    fontWeight: 'bold',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                    maxWidth: '95vw', // Prevent button from exceeding viewport
                }} onClick={goBack}>Back</button>
                <button style={{
                    backgroundImage: `url(${buttonImage})`,
                    backgroundSize: 'cover',
                    border: '2px solid black',
                    borderRadius: '10px',
                    padding: '10px 20px',
                    width: '120px',
                    fontFamily: 'Times New Roman, Times, serif',
                    fontSize: '16px',
                    fontWeight: 'bold',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                    maxWidth: '95vw',
                }} onClick={goHome}>Home</button>
                <button style={{
                    backgroundImage: `url(${buttonImage})`,
                    backgroundSize: 'cover',
                    border: '2px solid black',
                    borderRadius: '10px',
                    padding: '10px 20px',
                    width: '120px',
                    fontFamily: 'Times New Roman, Times, serif',
                    fontSize: '16px',
                    fontWeight: 'bold',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                    maxWidth: '95vw',
                }} onClick={handleSaveProgress}>Save</button>
            </div>
            {/* Sticky Footer with duplicated buttons */}
            <footer
                style={{
                    position: 'fixed',
                    bottom: 0,
                    left: 0,
                    width: '100vw', // Changed from '100%' to '100vw' for consistency
                    maxWidth: '100vw', // Prevent overflow on mobile
                    backgroundColor: '#3B839B',
                    border: '2px solid black',
                    borderRadius: '10px 10px 0 0',
                    boxShadow: '3px 3px 5px rgba(0, 0, 0, 0.3)',
                    padding: '10px',
                    textAlign: 'center',
                    zIndex: 1000,
                    minHeight: '60px',
                    display: 'flex',
                    justifyContent: 'center',
                    gap: '10px',
                    boxSizing: 'border-box', // Ensure padding is included in width
                    overflow: 'hidden', // Prevent content overflow
                }}
            >
                <button
                    style={{
                        backgroundImage: `url(${buttonImage})`,
                        backgroundSize: 'cover',
                        border: '2px solid black',
                        borderRadius: '10px',
                        padding: '10px 20px',
                        width: '120px',
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '16px',
                        fontWeight: 'bold',
                        boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                    }}
                    onClick={goBack}
                >Back</button>
                <button
                    style={{
                        backgroundImage: `url(${buttonImage})`,
                        backgroundSize: 'cover',
                        border: '2px solid black',
                        borderRadius: '10px',
                        padding: '10px 20px',
                        width: '120px',
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '16px',
                        fontWeight: 'bold',
                        boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                    }}
                    onClick={goHome}
                >Home</button>
                <button
                    style={{
                        backgroundImage: `url(${buttonImage})`,
                        backgroundSize: 'cover',
                        border: '2px solid black',
                        borderRadius: '10px',
                        padding: '10px 20px',
                        width: '120px',
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '16px',
                        fontWeight: 'bold',
                        boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                    }}
                    onClick={handleSaveProgress}
                >Save</button>
            </footer>
            <style>
                {`
                html, body, #root {
                    box-sizing: border-box;
                    width: 100vw;
                    min-width: 0;
                    margin: 0;
                    padding: 0;
                }
                * {
                    box-sizing: inherit;
                }
                @media (max-width: 900px) {
                    .healing-formulas-nav-btn-row,
                    footer {
                        width: 100vw !important;
                        max-width: 100vw !important;
                        min-width: 0 !important;
                        flex-wrap: wrap !important;
                        justify-content: center !important;
                        gap: 10px !important;
                        margin-left: 0 !important;
                        margin-right: 0 !important;
                        padding-left: 0 !important;
                        padding-right: 0 !important;
                    }
                    .healing-formulas-nav-btn-row button,
                    footer button {
                        width: 40vw !important;
                        min-width: 80px !important;
                        max-width: 180px !important;
                        font-size: 15px !important;
                        padding: 10px 0 !important;
                        margin: 0 !important;
                    }
                    div[style*="display: grid"] {
                        grid-template-columns: repeat(2, 1fr) !important;
                        max-width: 100vw !important;
                    }
                    div[style*="max-width: '256px'"], div[style*='max-width: 256px'] {
                        max-width: 95vw !important;
                        min-width: 0 !important;
                    }
                }
                @media (max-width: 600px) {
                    .healing-formulas-nav-btn-row,
                    footer {
                        width: 100vw !important;
                        max-width: 100vw !important;
                        min-width: 0 !important;
                        flex-wrap: wrap !important;
                        justify-content: center !important;
                        gap: 8px !important;
                        margin-left: 0 !important;
                        margin-right: 0 !important;
                        padding-left: 0 !important;
                        padding-right: 0 !important;
                    }
                    .healing-formulas-nav-btn-row button,
                    footer button {
                        width: 48vw !important;
                        min-width: 60px !important;
                        max-width: 120px !important;
                        font-size: 14px !important;
                        padding: 8px 0 !important;
                        margin: 0 !important;
                    }
                    div[style*="display: grid"] {
                        grid-template-columns: repeat(1, 1fr) !important;
                        max-width: 100vw !important;
                    }
                    div[style*="max-width: '256px'"], div[style*='max-width: 256px'] {
                        max-width: 98vw !important;
                        min-width: 0 !important;
                    }
                }
                `}
            </style>
        </div>
    );
}

// --- You can safely add new helper functions, hooks, or exports below this line ---
// Example: 
// export function someNewHelper() { /* ... */ }
